module.exports = __webpack_public_path__ + "static/sphere_faq_bg-69368c3525e531668d235719f7209548.jpg";